export default __webpack_public_path__ + "static/media/svu.dc971945.mp3";